import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { DefaultShowHideDirective } from '../../../flex-layout/show-hide';
import { ContentAnimDirective } from '../../product-layout/content-anim.directive';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { NgClass, NgStyle } from '@angular/common';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { MatIcon } from '@angular/material/icon';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { NgOptimizedImageComponent } from '../ng-optimized-image/ng-optimized-image.component';
import { DefaultClassDirective } from '../../../flex-layout/class';
import { DefaultLayoutAlignDirective } from '../../../flex-layout/custom-layout-align';

@Component({
  selector: 'calsoft-stepflow-layout',
  imports: [DefaultShowHideDirective, ContentAnimDirective, DefaultStyleDirective, NgStyle, DefaultLayoutDirective, DefaultLayoutAlignDirective, NgClass, DefaultClassDirective, DefaultFlexDirective, MatIcon, EditorTextComponent, NgOptimizedImageComponent],
  templateUrl: './stepflow-layout.component.html',
  styleUrl: './stepflow-layout.component.scss'
})
export class StepflowLayoutComponent {

  
  public serverPath1 = environment.commonImageApi + '/commonSlider/';

  public serverPath = environment.commonImageApi + '/home/';

  @Input() item: any;

  @Input() img: any;

  @Input() data: any;


  stepType:any=1

  constructor() { }


  ngOnInit() {
  
    
  }

  
}
